import Link from 'next/link'
import { FC } from 'react'

import { useTranslation } from '@/i18n/configs'

import { pagesPath } from '@/lib/$path'

export type FooterProps = {
  ptSize?: 'sm' | 'md'
}

export const Footer: FC<FooterProps> = ({ ptSize = 'sm' }) => {
  const t = useTranslation()

  return (
    <footer
      className={`relative z-20 flex flex-col items-center ${
        ptSize === 'sm' ? 'pt-[24px]' : 'pt-[64px]'
      } mx-auto h-[106px] max-w-[375px] pb-[24px] text-xs`}
    >
      <div className="mb-[24px] space-x-[24px] font-medium">
        <Link href="https://emole.co.jp/">
          <a>{t('footer.company_overview_text')}</a>
        </Link>
        <Link href={pagesPath.rules.privacy_policy.$url()}>
          <a>{t('footer.privacy_policy_text')}</a>
        </Link>
        <Link href={pagesPath.question.$url()}>
          <a>{t('footer.faq_text')}</a>
        </Link>
      </div>
      <div className="font-normal">
        <p>© emole,inc.</p>
      </div>
    </footer>
  )
}
